import PropTypes from 'prop-types';
import React from 'react';
import { IconBell, IconMessageRead, IconMute, IconPinChannel, IconUnpin, IconUnread } from '../../../assets/images';
import {
   useChannelIsMuted,
   useChannelIsPinned,
   useChannelStatus,
   useChannelUnreadCount,
   useUserRole,
} from '../../../Slice';
import { handleMarkAsRead, handleMarkAsUnread, handleMuteChannel, handlePinChannel } from '../../utils';

export const MuteAction = ({ channelId, onClick }) => {
   const isMuted = useChannelIsMuted(channelId);
   const icon = isMuted ? <IconMute style={{ minWidth: '18px' }} /> : <IconBell style={{ minWidth: '18px' }} />;
   const label = isMuted ? 'Unmute notification' : 'Mute notification';
   const userRole = useUserRole(channelId);
   const activeStatus = useChannelStatus(channelId);
   const removechannel = activeStatus === 'DELETED';
   const filterChannel = removechannel || userRole === 0 || activeStatus === 'INACTIVE';

   if (filterChannel) {
      return null;
   }

   return (
      <button
         key={`${channelId}`}
         className={`menu_option`}
         onClick={e => {
            e.stopPropagation();
            handleMuteChannel({ channelId, action: isMuted ? 0 : 1 });
            onClick?.(e);
         }}>
         {icon} {label}
      </button>
   );
};

MuteAction.propTypes = {
   onClick: PropTypes.func,
   channelId: PropTypes.string,
};

export const PinAction = ({ channelId, onClick, defaultRender = true }) => {
   const pinnedAt = useChannelIsPinned(channelId);
   const { icon, label } = React.useMemo(() => {
      if (pinnedAt > 0) {
         return {
            icon: <IconUnpin style={{ width: 18, height: 18 }} />,
            label: 'Unpin chat',
         };
      }
      return {
         icon: <IconPinChannel style={{ width: 18, height: 18 }} />,
         label: 'Pin chat',
      };
   }, [pinnedAt]);

   if (!defaultRender) {
      return pinnedAt > 0 ? <IconPinChannel style={{ minWidth: '18px' }} /> : null;
   }

   const handleClick = e => {
      e.stopPropagation();
      handlePinChannel({ channelId, action: pinnedAt > 0 ? 0 : 1 });
      onClick?.(e);
   };

   return (
      <button key={channelId} className="menu_option" onClick={handleClick}>
         {icon} {label}
      </button>
   );
};

PinAction.propTypes = {
   onClick: PropTypes.func,
   channelId: PropTypes.string,
   defaultRender: PropTypes.bool,
};

export const MarkAsReadUnreadAction = ({ channelId, onClick, defaultRender = true }) => {
   const unreadCount = useChannelUnreadCount(channelId);
   const { icon, label } = React.useMemo(() => {
      if (unreadCount > 0 || unreadCount === -1) {
         return {
            icon: <IconUnread style={{ width: 18, height: 18 }} />,
            label: 'Mark as read',
         };
      }
      return {
         icon: <IconMessageRead style={{ width: 18, height: 18 }} />,
         label: 'Mark as unread',
      };
   }, [unreadCount]);

   if (!defaultRender) {
      return unreadCount > 0 ? (
         <IconMessageRead style={{ minWidth: '18px' }} />
      ) : (
         <IconUnread style={{ minWidth: '18px' }} />
      );
   }

   const handleClick = e => {
      e.stopPropagation();
      if (unreadCount > 0 || unreadCount === -1) {
         handleMarkAsRead({ channelId, isOnPress: true });
      } else {
         handleMarkAsUnread({ channelId });
      }
      onClick?.(e);
   };
   return (
      <button key={channelId} className="menu_option" onClick={handleClick}>
         {icon} {label}
      </button>
   );
};

MarkAsReadUnreadAction.propTypes = {
   onClick: PropTypes.func,
   channelId: PropTypes.string,
   defaultRender: PropTypes.bool,
};
